import React, { useState, useEffect } from 'react'
import {
  IntlProvider,
  MissingTranslationError,
  MessageFormatError,
  MissingDataError,
  InvalidConfigError,
  UnsupportedFormatterError,
} from 'react-intl'

import i18n from '../i18n'
import { I18nConfig } from '../model'

interface I18nProviderProps {
  children: React.ReactNode
}

type IntlError =
  | MissingTranslationError
  | MessageFormatError
  | MissingDataError
  | InvalidConfigError
  | UnsupportedFormatterError

function I18nProvider({ children }: I18nProviderProps) {
  const [{ locale, defaultLocale, messages }, setProviderConfig] = useState<I18nConfig>(
    i18n.getConfig(),
  )

  const updateProviderConfig = (config: I18nConfig) => {
    setProviderConfig(config)
  }

  const intlError = (error: IntlError): void => {
    // eslint-disable-next-line no-console
    console.error(error)
  }

  useEffect(() => {
    i18n.subscribe(updateProviderConfig)
    return () => {
      i18n.unsubscribe(updateProviderConfig)
    }
  }, [])

  return (
    <IntlProvider
      locale={locale}
      defaultLocale={defaultLocale}
      messages={messages}
      onError={intlError}
    >
      {children}
    </IntlProvider>
  )
}

export default I18nProvider
